/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const user = {
  anonymousConsents: {
    preferences: 'Preferencias de consentimiento',
    dialog: {
      title: 'Gestión del consentimiento',
      legalDescription:
        "We use cookies/browser's storage to personalize the content and improve user experience. We also might share the data about your site usage with our social media. For more, please review our privacy policy.",
      selectAll: 'Seleccionar todo',
      clearAll: 'Borrar todo',
    },
    banner: {
      title: 'Este sitio web utiliza cookies',
      description:
        "We use cookies/browser's storage to personalize the content and improve user experience.",
      allowAll: 'Permitir todo',
      viewDetails: 'Ver detalles',
    },
  },
  checkoutLogin: {
    emailAddress: {
      label: 'Dirección de correo electrónico',
      placeholder: 'Ingrese el correo electrónico',
    },
    confirmEmail: {
      label: 'Confirmar correo electrónico',
      placeholder: 'Confirmar correo electrónico',
    },
    continue: 'Continuar',
    emailIsRequired: 'Formato de correo electrónico no válido',
    emailsMustMatch: 'El correo electrónico no coincide',
  },
  authMessages: {
    signedOutSuccessfully: 'Ha cerrado la sesión correctamente.',
  },
};
